import { render, staticRenderFns } from "./TcAebond.vue?vue&type=template&id=6a280c42&scoped=true"
import script from "./TcAebond.vue?vue&type=script&lang=js"
export * from "./TcAebond.vue?vue&type=script&lang=js"
import style0 from "./TcAebond.vue?vue&type=style&index=0&id=6a280c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a280c42",
  null
  
)

export default component.exports